<form [formGroup]="formGroup">
  <mat-radio-group class="indent-radio-group" formControlName="colorTheme">
    <mat-radio-button value="theme-default">{{ 'TOOLBAR.COLOR_THEMES.LIGHT' | translate }}</mat-radio-button>
    <mat-radio-button value="theme-blue-gray-dark">{{ 'TOOLBAR.COLOR_THEMES.DARK' | translate }}</mat-radio-button>
    <mat-radio-button class="mb-12" value="system">{{ 'TOOLBAR.COLOR_THEMES.SYSTEM' | translate }}</mat-radio-button>
  </mat-radio-group>
</form>
